import { Injectable } from '@angular/core';
import { transaction } from '@datorama/akita';
import { DoenKidsGenericApiProvider } from 'src/providers/generic.provider';
import { OrganizationUnitFetchEventsStore } from './organization-unit-fetch-events.store';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrganizationUnitFetchEventsService {
  @transaction()
  async fetch(
    organizationUnitId: number,
    limit: number = 100,
    skip: number = 0,
  ) {
    const response = await firstValueFrom(this.$baseApi.genericGetCall(
      `/customer/organization-unit/${organizationUnitId}/access-log?limit=${limit}&skip=${skip}`,
    )) as any;

    const hits = response?.items ?? [];
    this.store.set(hits);

    this.store.update({
      limit,
      skip,
      total: response?.total ?? 0,
    });

    return hits;
  }

  constructor(
    private store: OrganizationUnitFetchEventsStore,
    private $baseApi: DoenKidsGenericApiProvider,
  ) { }
}
